import { ReactElement } from 'react';
import cn from 'classnames';

import cms from '../../data/cms.json';
import styles from './Banner.module.scss';
import pomeranc from '../../images/pomeranc.png';
import lilek from '../../images/lilek.png';
import banan from '../../images/banan.png';
import { Title } from '../Title/Title';
import he from 'he';
import { getDataTest } from '../../utils/dataTests';

interface BannerProps {
    className?: string;
}

export const Banner = ({ className, ...props }: BannerProps): ReactElement | null => {
    const resolveImage = (key: string) => {
        switch (key) {
            case 'pomeranc':
                return pomeranc;
            case 'lilek':
                return lilek;
            case 'banan':
                return banan;
            default:
                break;
        }
    };
    return (
        <div className={cn(styles.wrapper, className)} {...props}>
            <div className={styles.inner} data-test={getDataTest(props, 'Inner')}>
                <Title tag="h2" className={cn(styles.title, 'mb-4')} data-test={getDataTest(props, 'Title')}>
                    {cms.banner.title}
                </Title>

                <p className={cn('mb-9 mb-6-m', styles.text)} data-test={getDataTest(props, 'Text')}>
                    {cms.banner.text}
                </p>

                <ul className={styles.list} data-test={getDataTest(props, 'Items')}>
                    {cms.banner.items.map((item, i: number) => (
                        <li key={i} className={styles.item} data-test={getDataTest(props, `Item[${i}]`)}>
                            <img
                                src={resolveImage(item.image)}
                                alt={item.title}
                                className={styles.image}
                                data-test="image"
                            />
                            <Title tag="h3" className={styles.itemTitle} data-test="title">
                                {item.title}
                            </Title>
                            <div data-test="text">{he.decode(item.text)}</div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};
